module.exports = __webpack_public_path__ + "img/logo-no-text.61cc19cc.svg";